import { passengersClassesLib } from './passengers-classes';
import { multiCityLib } from './multi-city';
import { payloadLib } from './payload';
import { searchFormValidation } from './validations';
import { formatterLib } from './search-form-formatter';

export const searchFormLib = {
  ...passengersClassesLib,
  ...multiCityLib,
  ...payloadLib,
  ...searchFormValidation,
  ...formatterLib,
};
